import React from "react";
import App from "./App";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./styles/App.css";
import "./styles/theme.css";
import { api } from "./services/api";
import { fetchProfile } from "./redux/slices/authSlice";
import "./i18n";

// Hydrate token from localStorage
const token = localStorage.getItem("token");
if (token) {
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  store.dispatch(fetchProfile());
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
